<template>
  <div>
    <div class="loginBox">
      <div class="t1">用户快捷登录</div>
      <div class="t2">铜仁学院省级专业技术人员继续教育培训平台</div>

      <div class="userInfo">
        <div class="u1">账号</div>
        <div>
          <input type="text" v-model="userInfo.userName" class="u2" placeholder="请输入您的手机号码或身份证号码" />
        </div>

        <div class="u1" style="margin-top: 24px">密码</div>
        <div>
          <input type="password" v-model="userInfo.userPasswd" class="u2" placeholder="请输入您的密码" />
        </div>
      </div>

      <div class="btn" @click="login">立即登录</div>

      <div class="zc" @click="goRegister">没有账号？去注册</div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { login } from '@/api/login.js';
import { mapMutations } from 'vuex';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      userInfo: {
        userName: '',
        userPasswd: ''
      },
      loginFalg: false //5s只能点一次
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    ...mapMutations('m_user', ['updateToken']),
    //去注册
    goRegister() {
      this.$router.push({
        path: '/register'
      });
    },
    login() {
      if (this.userInfo.userName == '' || this.userInfo.userName == undefined) {
        this.$utils.showToast('请输入用户名！');
        return false;
      } else if (this.userInfo.userPasswd == '' || this.userInfo.userPasswd == undefined) {
        this.$utils.showToast('请输入密码！');
        return false;
      }
      if (this.loginFalg) {
        this.$utils.showToast('按钮点击过快，请5s后重试~');
        return false;
      }
      this.loginFalg = true;
      setTimeout(() => {
        this.loginFalg = false;
      }, 5000);
      login(this.userInfo).then(res => {
        if (res.data.data.msg == '登录成功') {
          this.updateToken(res.data.data.token);
          // 拿到密钥存在本地存储
          localStorage.setItem('token', res.data.data.token);
          localStorage.removeItem('bmShow');
          this.$utils.showToast('登录成功！');
          setTimeout(() => {
            this.$router.back();
          }, 1000);
        } else {
          this.$utils.showToast(res.data.data.msg);
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.loginBox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 103px 22px 0 22px;
  .t1 {
    font-size: 26px;
    color: #333;
    font-weight: bold;
  }
  .t2 {
    margin-top: 7px;
    color: #667280;
    font-size: 13px;
  }
  .userInfo {
    margin-top: 30px;
    .u1 {
      font-size: 17px;
      color: #333;
      font-weight: 600;
    }
    .u2 {
      margin-top: 12px;
      width: 100%;
      height: 48px;
      background: #f0f2f3;
      border-radius: 8px 8px 8px 8px;
      padding-left: 15px;
      border: 0 !important;
    }
  }
  .btn {
    width: 100%;
    margin-top: 30px;
    height: 48px;
    background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
    box-shadow: 0px 6px 12px 0px #c5d6ff;
    border-radius: 8px 8px 8px 8px;
    text-align: center;
    line-height: 48px;
    color: #ffffff;
    font-size: 15px;
  }
  .zc {
    width: 100%;
    text-align: center;
    margin-top: 20px;
    color: #4076f6;
    font-size: 15px;
  }
}
</style>
